import { DateConverter } from 'src/app/core/services/mapper/converters';
import { EntrepriseBase } from './entreprise-base.model';
import * as moment from 'moment';
import { Structure } from './structure.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Entreprise extends EntrepriseBase {
    static jsonMap = {
        ...EntrepriseBase.jsonMap,
        structureJuridique: { key: 'structureJuridique', converter: new (ClassConverterFactory.build(Structure))(), optional: true },
        numeroAdherent: { key: 'numeroAdherent', optional: true, default: '' },
        cotisationAJour: { key: 'cotisationAJour', optional: true },
        dateAdhesion: { key: 'dateAdhesion', converter: new DateConverter(), optional: true },
        dateDemission: { key: 'dateDemission', converter: new DateConverter(), optional: true },
        estMorale: { key: 'estMorale', optional: true },
        siret: { key: 'siret', optional: true, default: '' },
        numeroTVA: { key: 'numeroTVA', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        departement: { key: 'departement', optional: true, default: '' },
        numeroReconnaissance: { key: 'numeroReconnaissance', optional: true, default: '' },
        entrepriseLiee: { key: 'entrepriseLiee', converter: new (ClassConverterFactory.build(EntrepriseBase))(), optional: true },
        cultureBio: { key: 'cultureBio', optional: true },
        codeComptable: { key: 'codeComptable', optional: true, default: '' },
        commentaire: { key: 'commentaire', optional: true, default: '' }
    };

    public structureJuridique: Structure;
    public numeroAdherent: string;
    public cotisationAJour: boolean;
    dateAdhesion: moment.Moment;
    dateDemission: moment.Moment;
    public estMorale: boolean;
    public siret: string;
    public numeroTVA: string;
    public adresse: string;
    public codePostal: string;
    public commune: string;
    public departement: string;
    public numeroReconnaissance: string;
    public entrepriseLiee: EntrepriseBase;
    public cultureBio: boolean;
    public codeComptable: string;
    public commentaire: string;
    public especesProduites: string;
    public estEngageeVer: boolean;
}
